var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _ellipse, _circle, _path, _path2, _rect13, _rect14, _rect15, _rect16, _rect17, _g, _g2, _circle2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoBuild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 664,
    height: 384,
    viewBox: "0 0 664 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 176,
    width: 197,
    height: 160,
    rx: 6,
    fill: "#E7EEFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 176,
    width: 196,
    height: 160,
    rx: 6,
    fill: "#E7EEFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 177,
    width: 195,
    height: 158,
    rx: 5,
    stroke: "#BDD0FB",
    strokeWidth: 2,
    strokeDasharray: "10 10"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 276,
    width: 164,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 290,
    width: 164,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 276,
    width: 164,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 262,
    width: 164,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 262,
    width: 164,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 242,
    width: 74,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 242,
    width: 75,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 307,
    height: 155,
    rx: 6,
    fill: "#BDD0FB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    width: 307,
    height: 155,
    rx: 6,
    fill: "#E7EEFE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.5,
    cy: 212,
    rx: 18.5,
    ry: 18,
    fill: "#BDD0FB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 212,
    r: 18,
    fill: "#BDD0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.798 67.8563L176.697 91.8563L169.328 102.778L154.046 79.9281L130.031 44L82 116H87.458H225L192.798 67.8563Z",
    fill: "#E7EEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 50.5C180 56.3636 175.228 61 169.501 61C163.639 61 159.003 56.2273 159.003 50.5C158.867 44.7727 163.639 40 169.365 40C175.228 40 180 44.7727 180 50.5Z",
    fill: "url(#paint0_linear)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 80,
    width: 269,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 66,
    width: 269,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 39,
    width: 125,
    height: 14,
    rx: 7,
    fill: "#BDD0FB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 100,
    width: 81,
    height: 20,
    rx: 2,
    fill: "#1DA2F8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 296,
    width: 83,
    height: 20,
    fill: "url(#paint1_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454,
    y: 202.987,
    width: 206,
    height: 160,
    rx: 6,
    fill: "#E7EEFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.597 357.488C548.597 357.34 548.597 357.192 548.597 357.043C548.573 351.889 548.549 346.727 548.533 341.572C548.533 340.018 549.349 338.745 550.728 338.285C551.884 337.894 553.105 337.894 554.261 338.261C555.608 338.675 556.48 339.94 556.488 341.354C556.511 343.626 556.511 345.899 556.519 348.172C556.519 348.367 556.519 348.554 556.519 348.804C556.86 348.804 557.161 348.804 557.462 348.804C558.04 348.804 558.619 348.789 559.205 348.796C560.338 348.812 561.13 349.351 561.558 350.374C561.661 350.608 561.78 350.678 562.026 350.671C562.786 350.655 563.555 350.655 564.315 350.655C565.519 350.647 566.431 351.256 566.819 352.373C566.906 352.615 567.025 352.654 567.247 352.654C567.983 352.646 568.72 352.639 569.457 352.646C570.899 352.662 571.977 353.724 571.984 355.146C572 358.496 572.008 361.846 571.992 365.204C571.992 365.634 571.874 366.079 571.707 366.485C570.075 370.468 568.419 374.443 566.771 378.418C566.359 379.402 565.607 379.925 564.521 379.933C561.978 379.949 559.435 379.949 556.892 379.964C555.069 379.972 553.255 379.988 551.433 379.988C549.737 379.996 548.692 378.965 548.684 377.301C548.676 376.263 548.7 375.224 548.66 374.185C548.644 373.842 548.557 373.459 548.383 373.162C545.792 368.742 543.193 364.33 540.587 359.917C539.501 358.082 539.945 356.2 541.743 355.044C542.369 354.638 542.971 354.177 543.74 354.06C545.213 353.834 546.386 354.333 547.226 355.544C547.67 356.184 548.082 356.856 548.501 357.512C548.533 357.504 548.565 357.496 548.597 357.488ZM556.543 350.858C556.543 351.21 556.543 351.498 556.543 351.78C556.551 353.443 556.559 355.106 556.559 356.77C556.559 357.527 555.885 358.019 555.196 357.785C554.768 357.637 554.515 357.246 554.515 356.707C554.499 354.255 554.491 351.795 554.475 349.343C554.467 346.758 554.451 344.173 554.443 341.588C554.436 340.596 553.913 340.089 552.899 340.089C552.677 340.089 552.447 340.089 552.225 340.089C551.084 340.089 550.585 340.581 550.585 341.697C550.609 346.945 550.633 352.194 550.649 357.442C550.656 358.715 550.672 359.987 550.664 361.26C550.664 361.956 550.102 362.416 549.42 362.229C549.151 362.159 548.874 361.909 548.715 361.674C547.638 360.042 546.6 358.387 545.538 356.739C545.063 356.005 544.31 355.841 543.566 356.309C543.32 356.465 543.074 356.622 542.837 356.778C541.981 357.332 541.823 357.996 542.345 358.871C545.039 363.392 547.741 367.914 550.427 372.444C550.601 372.741 550.696 373.123 550.704 373.467C550.744 374.74 550.728 376.013 550.736 377.286C550.744 377.817 550.862 377.934 551.385 377.934C555.711 377.926 560.029 377.911 564.355 377.911C564.696 377.911 564.878 377.778 565.005 377.473C566.573 373.662 568.158 369.851 569.726 366.04C569.837 365.767 569.932 365.462 569.932 365.173C569.94 361.87 569.932 358.574 569.925 355.27C569.925 354.857 569.758 354.7 569.354 354.693C568.657 354.685 567.96 354.708 567.263 354.7C567.025 354.7 566.938 354.771 566.946 355.013C566.961 355.723 566.961 356.442 566.961 357.153C566.961 357.527 566.977 357.902 566.969 358.285C566.961 358.933 566.565 359.363 565.979 359.378C565.385 359.394 564.949 358.972 564.909 358.316C564.902 358.215 564.909 358.105 564.909 358.004C564.902 356.458 564.902 354.911 564.894 353.365C564.894 352.842 564.767 352.717 564.244 352.717C563.563 352.717 562.873 352.717 562.192 352.725C562.057 352.725 561.915 352.725 561.756 352.725C561.756 352.967 561.756 353.154 561.756 353.334C561.764 354.685 561.772 356.036 561.772 357.387C561.772 358.09 561.344 358.558 560.726 358.558C560.14 358.551 559.728 358.082 559.712 357.395C559.704 357.137 559.712 356.871 559.712 356.614C559.704 354.896 559.696 353.185 559.688 351.467C559.688 351.17 559.633 350.874 559.276 350.866C558.381 350.835 557.494 350.858 556.543 350.858Z",
    fill: "#819CDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.543 350.857C557.485 350.857 558.381 350.841 559.276 350.865C559.633 350.873 559.688 351.169 559.688 351.466C559.696 353.184 559.704 354.895 559.712 356.613C559.712 356.87 559.712 357.136 559.712 357.394C559.728 358.081 560.14 358.55 560.726 358.557C561.344 358.565 561.772 358.089 561.772 357.386C561.772 356.035 561.764 354.684 561.756 353.333C561.756 353.153 561.756 352.973 561.756 352.724C561.922 352.724 562.057 352.724 562.192 352.724C562.873 352.724 563.562 352.716 564.244 352.716C564.759 352.716 564.893 352.841 564.893 353.364C564.901 354.91 564.901 356.457 564.909 358.003C564.909 358.104 564.909 358.214 564.909 358.315C564.949 358.971 565.377 359.393 565.979 359.377C566.565 359.362 566.961 358.932 566.969 358.284C566.977 357.909 566.961 357.534 566.961 357.152C566.953 356.441 566.961 355.722 566.945 355.012C566.937 354.77 567.024 354.692 567.262 354.699C567.959 354.707 568.657 354.692 569.354 354.692C569.766 354.692 569.924 354.856 569.924 355.269C569.932 358.573 569.94 361.869 569.932 365.172C569.932 365.461 569.837 365.766 569.726 366.039C568.157 369.85 566.581 373.661 565.004 377.472C564.877 377.777 564.695 377.91 564.355 377.91C560.029 377.917 555.711 377.925 551.385 377.933C550.854 377.933 550.735 377.816 550.735 377.285C550.727 376.012 550.743 374.739 550.704 373.466C550.696 373.122 550.601 372.74 550.426 372.443C547.748 367.913 545.039 363.391 542.345 358.87C541.822 357.995 541.981 357.331 542.836 356.777C543.082 356.621 543.32 356.464 543.565 356.308C544.31 355.84 545.063 356.004 545.538 356.738C546.6 358.386 547.638 360.033 548.715 361.673C548.873 361.915 549.151 362.158 549.42 362.228C550.101 362.415 550.656 361.955 550.664 361.259C550.672 359.986 550.656 358.714 550.648 357.441C550.624 352.193 550.601 346.944 550.585 341.696C550.577 340.58 551.084 340.088 552.225 340.088C552.447 340.088 552.676 340.088 552.898 340.088C553.912 340.088 554.435 340.595 554.443 341.587C554.451 344.172 554.467 346.757 554.475 349.342C554.483 351.794 554.499 354.254 554.514 356.706C554.514 357.245 554.776 357.636 555.196 357.784C555.885 358.018 556.559 357.534 556.559 356.769C556.559 355.105 556.551 353.442 556.543 351.779C556.543 351.49 556.543 351.209 556.543 350.857Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 556.5,
    cy: 282.487,
    r: 30.5,
    fill: "url(#paint2_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M566.87 283.182L549.18 293.247L549.18 273.117L566.87 283.182Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 436,
    y: 201.987,
    width: 228,
    height: 182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0279167 0 0 0 0 0.176433 0 0 0 0 0.558333 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 159.015,
    y1: 50.4947,
    x2: 180,
    y2: 50.4947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 274.059,
    y1: 305.995,
    x2: 357.001,
    y2: 305.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 526.044,
    y1: 282.472,
    x2: 587.001,
    y2: 282.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 42,
    fill: "white",
    transform: "translate(540 337.987)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBuild);
export default __webpack_public_path__ + "static/media/info-build.060c7f67.svg";
export { ForwardRef as ReactComponent };